export default __webpack_public_path__ + "static/before-cf29bfe77cc0d99156be322a51356cd2.png";